import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { Placeholder } from "rsuite";
import * as streamReportService from "../../../services/streamReport.service";

const StreamChart = ({ filter, From }) => {
    const [streamChartData, setStreamChartData] = useState([]);
    const [loadingStream, setLoadingStream] = useState(true);

    useEffect(() => {
        if (From === "StreamReport") {
            setLoadingStream(true);
            streamReportService.chart(filter)
                .then((res) => {
                    const data = Array.isArray(res?.data) ? res.data : [];
                    setStreamChartData(data);
                    setTimeout(() => setLoadingStream(false), 500);
                })
                .catch((err) => {
                    console.error("Error:", err);
                    setLoadingStream(false);
                });
        }
    }, [filter, From]);

    // Format Categories: "09 Feb" format (Fixed Error)
    const categories = streamChartData.map(d => {
        const date = new Date(d._id);
        // "numeric" or "2-digit" are valid options
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
    });

    const areaOptions = {
        chart: { type: "area", toolbar: { show: false }, zoom: { enabled: false } },
        colors: ["#10B981"],
        stroke: { curve: "smooth", width: 3 },
        fill: {
            type: "gradient",
            gradient: { shadeIntensity: 1, opacityFrom: 0.45, opacityTo: 0.05 }
        },
        markers: {
            size: 5,
            colors: ["#fff"],
            strokeColors: "#10B981",
            strokeWidth: 3,
            hover: { size: 7 }
        },
        xaxis: {
            categories: categories,
            axisBorder: { show: false },
            title: { text: "Date", style: { fontWeight: 600 } }
        },
        yaxis: {
            min: 0,
            forceNiceScale: true,
            labels: { formatter: (val) => Math.floor(val) }
        },
        grid: { strokeDashArray: 5, borderColor: "#e5e7eb" }
    };

    // const barOptions = {
    //     chart: { type: 'bar', toolbar: { show: false } },
    //     plotOptions: { bar: { borderRadius: 6, columnWidth: '25%' } },
    //     colors: ["#4776E6"],
    //     fill: {
    //         type: 'gradient',
    //         gradient: {
    //             gradientToColors: ['#8E54E9'],
    //             stops: [0, 100],
    //             colorStops: [
    //                 { offset: 0, color: "#D1C4E9", opacity: 1 },
    //                 { offset: 100, color: "#4776E6", opacity: 1 }
    //             ]
    //         }
    //     },
    //     xaxis: { categories: categories, axisBorder: { show: false } },
    //     yaxis: { min: 0, forceNiceScale: true, labels: { formatter: (val) => Math.floor(val) } }
    // };

    if (loadingStream) return <Placeholder.Paragraph rowHeight={400} active rows={1} />;

    return (
        <div className="row">
            <div className="col-12"> {/* Full width on all screen sizes */}
                <div
                    className="card custom-card bg-white p-4 shadow-sm mb-3"
                    style={{ borderRadius: "11px" }}
                >
                    <h6 className="main-content-label mb-3 text-uppercase">
                        Associates Registrations
                    </h6>
                    <Chart
                        options={areaOptions}
                        series={[{ name: "Count", data: streamChartData.map(d => d.total_comments || 0) }]}
                        type="area"
                        height={350}
                        width="100%" // ensures chart spans full card width
                    />
                </div>
            </div>
            {/* <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="card custom-card bg-white p-4 shadow-sm mb-3" style={{ borderRadius: "11px" }}>
                    <h6 className="main-content-label mb-3 text-uppercase">Associates Activity</h6>
                    <Chart options={barOptions} series={[{ name: "Activity", data: streamChartData.map(d => d.total_comments || 0) }]} type="bar" height={350} />
                </div>
            </div> */}
        </div>
    );
};

export default StreamChart;